import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../_metronic/_partials/controls";
import CoreCustomTable from "./component/CoreCustomTable";
import MfaBadge from "./component/MfaBadge";
import { ClearFiltersButton, FilterSelect, MFA_FILTER_OPTIONS, PageSizeSelect, SearchField } from "./component/TableFilters";
import {
  sortCaret,
  headerSortingClasses
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { useHistory } from "react-router-dom"
import { baseURLV1 } from "../service/API.js"
import Swal from "sweetalert2";
import axios from "axios";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import { Modal } from '@material-ui/core'
import { Formik, Form, Field } from "formik"
import { roleCheck } from '../service/role';
import { hasAction, displayMobile } from '../service/permissions';
import { apiMessage } from '../service/apiError';
export const Participants = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [_templateData, setTemplateData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [_totalSize, setTotalSize] = useState(100);
  const [isLoading, setIs_Loading] = useState(false);
  const [listError, setlistError] = useState('');
  const [id, setID] = useState(0);
  const [show, setShow] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  suhbeader.setTitle("Participants Management");
  const { user } = useSelector((state) => state.auth);
  const [listMasterModel, setListMasterModel] = useState([]);
  const [mobileNumber, setMobileNumber] = useState('')
  const [password, setPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [search, setSearch] = useState('');
  const [mfaFilter, setMfaFilter] = useState('')
  const history = useHistory();
  useEffect(() => {
    localStorage.removeItem('edit')
    checkAuth()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [roleList, setRoleList] = useState([]);
  const [canViewPii, setCanViewPii] = useState(false);
  const checkAuth =async()=> {
    
    const [data, pii] = await Promise.all([roleCheck('PARTICIPANT'), roleCheck('PARTICIPANT_PII')])
    setCanViewPii(pii.includes('VIEW'))
    setRoleList(data)
    console.log(data)
    if (!hasAction(data, 'VIEW')) {
      history.push('/auth/login')
      return
    }

    getListMasterModel(page, limit);
  }
  const handleClose = async () => {
    setShow(false)
  }
  const onSubmit = async (value) => {
    if (!canViewPii) return;
    const digits = String(value.mobile_number || '').replace(/\D/g, '')
    const mobile = digits.length === 9 ? `0${digits}` : digits
    if (!digits) {
      return Swal.fire("", "กรุณากรอกเบอร์โทรศัพท์", "warning");
    }
    if (!/^0\d{9}$/.test(mobile)) {
      return Swal.fire("", "เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก และเริ่มด้วย 0", "warning");
    }
    // Staff-only route. PUT /participant/:id no longer accepts mobile_number —
    // it updates by the id in the URL with no ownership check, so the number that
    // is the login identifier was taken out of the body any member can send.
    // That is what made this modal fail silently.
    const apiUrls = `${baseURLV1}/bo/participant/${id}/mobile`;
    setSaving(true)
    axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.data.access_token}`,
      },
      data: { mobile_number: mobile }
    })
      .then((res) => {
        Swal.fire("", "แก้ไขเบอร์โทรศัพท์สำเร็จ", "success");
        setID(0)
        setShow(false)
        getListMasterModel(page, limit, search, mfaFilter);
        setMobileNumber('')
      })
      .catch((err) => {
        // The modal used to close with no message at all, so a rejected edit was
        // indistinguishable from a successful one.
        Swal.fire("", apiMessage(err, "แก้ไขเบอร์โทรศัพท์ไม่สำเร็จ กรุณาลองใหม่"), "error");
      })
      .finally(() => setSaving(false));
  }

  const onSubmitResetPassword = async (value) => {
    if (!password) {
      return Swal.fire("", "you must fill password.", "warning")
    } else if(password.length <= 6) {
      return Swal.fire("", "Password must be at least 7 characters long.", "warning")
    }
    const apiUrls = `${baseURLV1}/bo/participant/resetPassword/${id}`
    axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.data.access_token}`,
      },
      data: {
        password: password
      }
    })
      .then((res) => {
        Swal.fire("", "reset password success.", "success");
        setShowResetPassword(false)
        setPassword('')
      })
      .catch((err) => {
        Swal.fire("", apiMessage(err, "รีเซ็ตรหัสผ่านไม่สำเร็จ กรุณาลองใหม่"), "error");
      });
  }

  const getListMasterModel = async (page, limit, search = '', mfa = '') => {
    setIs_Loading(true);
    setlistError('');
    //console.log(search.charAt(0), search.charAt(0) == '0')
    /*if (search.length > 1 && search.charAt(0) == '0' && search.charAt(1) != '0' && search.charAt(2) != '0' && search.charAt(3) != '0') {
      console.log(search.charAt(0))
      search = search.replace('0','')
    }*/
    const apiUrls = `${baseURLV1}/participant?page=${page}&limit=${limit}${search !== '' ? `&search=${encodeURIComponent(search)}` : ''}${mfa !== '' ? `&mfa=${mfa}` : ''}`;
    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.data.access_token}`,
      },
    })
      .then((res) => {
        res.data.data.map(item => {
          if (!item.mobile_number) {
            item.mobile_number = ''
          }

                  return null;
})
        setListMasterModel(res.data.data);
        setlistError('');

        var totalpage = Math.ceil(res.data.total / res.data.limit);
        setTotalPage(totalpage);
        setTotalSize(res.data.total);
        setLimit(res.data.limit);
        setTemplateData(allData);
      })
      .catch((err) => {
        // Used to leave the last successful rows on screen with no hint that the
        // refresh failed — and did nothing at all on a network error.
        setListMasterModel([]);
        setlistError(apiMessage(err, 'โหลดรายชื่อสมาชิกไม่สำเร็จ'));
      })
      .finally(() => setIs_Loading(false));
  };

  const _ISOString = (data) => {
    console.log(`${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`)
    return `${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`
    // console.log(Date(data).toISOString())
  };
  const columns = [

    {
      dataField: "firstname",
      text: "firstname",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            <p style={{ width: 100 }}>
              {row.firstname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "lastname",
      text: "lastname",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            <p style={{ width: 100 }}>
              {row.lastname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "email",
      text: "email",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            <p style={{ width: 200 }}>
              {row.email}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "mobile",
      text: "mobile",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (img, row, rowIndex) => {
        return (
          <div>
            <p style={{ width: 180 }}>
              {displayMobile(row.mobile_number)}
            </p>
          </div>
        );
      },
    },

    {
      dataField: "mfa_enabled",
      text: "MFA",
      formatter: (enabled) => <MfaBadge enabled={enabled} />,
    },

    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div className="d-flex flex-wrap" style={{ minWidth: '210px', gap: 8 }}>
            {canViewPii && hasAction(roleList, 'EDIT') &&<button
              type="button"
              className="btn btn-primary"
              onClick={() => editItem2({ id, row, rowIndex })}
            >
              Edit
            </button>}

            {hasAction(roleList, 'EDIT') &&<button
              type="button"
              className="btn btn-primary"
              onClick={() => onResetPassword({ id, row, rowIndex })}
            >
              Reset Password
            </button>}

            {(hasAction(roleList, 'EDIT') || hasAction(roleList, 'DELETE')) &&<button
              type="button"
              className="btn btn-warning"
              onClick={() => onResetMfa({ id, row })}
            >
              Reset MFA
            </button>}

            {/*<button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              Delete
            </button>*/}

          </div>
        );
      },
    },
    /*{
      text: "Image Management",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => ImageManagement({ row, rowIndex })}
            >
              Image
            </button>

          </div>
        );
      },
    },*/
  ];

  const _editItem = (data) => {
    history.push("/EditBanner", data);
  };

  const editItem2 = (data) => {
    console.log(data)
    setID(data.id)
    setShow(true)
    setMobileNumber(`${data.row.mobile_number}`)
  };

  const onResetPassword = (data) => {
    setID(data.id)
    setShowResetPassword(true)
    setPassword('')
  };

  // For the member whose registered phone is the problem — wrong digits at
  // registration, or a number they no longer control — so SMS recovery cannot
  // reach them. Also the way out of a lockout after eight wrong codes.
  const onResetMfa = (data) => {
    const name = [data.row.firstname, data.row.lastname].filter(Boolean).join(' ') || `#${data.id}`
    Swal.fire({
      title: 'รีเซ็ตการยืนยัน 2 ขั้นตอน?',
      text: `สมาชิก ${name}: อุปกรณ์ที่ผูกไว้จะใช้ไม่ได้ทันที และสมาชิกต้องสแกน QR ผูกแอปใหม่ตอนเข้าสู่ระบบครั้งถัดไป`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'รีเซ็ต',
      cancelButtonText: 'ยกเลิก',
    }).then((result) => {
      if (!result.value) return
      axios({
        method: 'post',
        url: `${baseURLV1}/bo/participant/${data.id}/mfa/reset`,
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${user.data.access_token}`,
        },
      })
        .then(() => {
          Swal.fire('', 'รีเซ็ตการยืนยัน 2 ขั้นตอนเรียบร้อย', 'success')
          getListMasterModel(page, limit, search, mfaFilter)
        })
        .catch((err) => {
          Swal.fire('', apiMessage(err, 'รีเซ็ตการยืนยัน 2 ขั้นตอนไม่สำเร็จ กรุณาลองใหม่'), 'error')
        })
    })
  };

  const _ImageManagement = (data) => {
    history.push("/EditNewsImage", data);
  };

  const _deleteItem = (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this limit point !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`${baseURLV1}/banner/${data.row.id}`)
          .then((res) => {
            Swal.fire("Deleted!", "Your model has been deleted.", "success");
            getListMasterModel(page, limit);
          })
          .catch((err) => {
            Swal.fire(
              "Deleted!",
              "Your model has been fail to deleted.",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your model is safe :)", "error");
      }
    });
  };
  const handleSearch = () => {
    if (!canViewPii && search) return;
    setPage(1);
    getListMasterModel(1, limit, search, mfaFilter);
  };

  // Clearing has to re-fetch, not just empty the fields. Leaving the previous
  // results under an empty toolbar is the state operators read as "no more matches".
  const handleClearFilters = () => {
    setSearch("");
    setMfaFilter("");
    setPage(1);
    getListMasterModel(1, limit, "", "");
  };

  // Paging and page-size used to drop the search term and re-fetch the unfiltered
  // list, so page 2 of a search silently showed everybody.
  const handlePageChange = (event, value) => {
    setPage(value);
    getListMasterModel(value, limit, search, mfaFilter);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
    getListMasterModel(1, event.target.value, search, mfaFilter);
  };

  const handleMfaFilterChange = (event) => {
    const next = event.target.value;
    setMfaFilter(next);
    setPage(1);
    getListMasterModel(1, limit, search, next);
  };

  return (
    <Card>
      <CardHeader title="Participants Management">
        <CardHeaderToolbar>
          {/*<Link to="/CreateBanner">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>*/}
        </CardHeaderToolbar>
      </CardHeader>
      <div className="row form-inline ml-4 mt-3">
        <div className="col-lg-4 col-md-4 col-sm-4">
          <div className="form-group">
            {/* The API searches these five columns — saying so stops operators
                guessing why a Customer ID or a phone number "does not work". */}
            <SearchField
              disabled={!canViewPii}
              placeholder="ค้นหา ชื่อ / นามสกุล / อีเมล / เบอร์โทร / Customer ID"
              value={search}
              onChange={setSearch}
              onSearch={handleSearch}
            />
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-3">
          <div className="form-group">
            <FilterSelect
              value={mfaFilter}
              onChange={handleMfaFilterChange}
              options={MFA_FILTER_OPTIONS}
            />
          </div>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-2">
          <div className="form-group">
            <button
              type="button"
              id="button"
              className="btn btn-primary"
              style={{ width: "100%" }}
              disabled={isLoading}
              onClick={() => handleSearch()}
            >
              {isLoading ? 'กำลังค้นหา...' : 'Search'}
            </button>
          </div>
        </div>
        <div className="col-lg-1 col-md-1 col-sm-1">
          <div className="form-group">
            <ClearFiltersButton
              show={Boolean(search || mfaFilter)}
              onClear={handleClearFilters}
            />
          </div>
        </div>
      </div>
      <CardBody>


        {/* /Search Btn/ */}

        {/* <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> */}


        <CoreCustomTable
          data={listMasterModel}
          columns={columns}
          loading={isLoading}
          error={listError}
          emptyText="ไม่พบสมาชิกที่ตรงกับเงื่อนไข"
        />
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="mt-3">
                <PageSizeSelect
                  label="Items per Page:"
                  value={limit}
                  onChange={handlePageSizeChange}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
        <Modal
          open={show}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5" style={{ marginTop: "30px", marginLeft: "30px", marginRight: "30px" }}>
                <span style={{ fontSize: "20px" }}>Change Mobile Number</span>
                <button type="button"
                  className="btn btn-xs btn-icon btn-light btn-hover-primary"
                  id="kt_quick_user_close"
                  onClick={() => handleClose()}
                >
                  <i className="ki ki-close icon-xs text-muted" />
                </button>
              </div>

              <div className="modal-body">
                <Formik
                  initialValues={{
                    mobile_number: mobileNumber,

                  }}


                  onSubmit={onSubmit}
                  render={(formProps) => {
                    return (
                      <Form className="col">
                        <div className="row">

                          <Field
                            type="number"
                            name="mobile_number"
                            className="form-control"
                            placeholder="New Mobile Number"
                            style={{
                              height: "38px",
                              width: "530px",
                              backgroundColor: "#F4F6F9",
                              borderRadius: "5px",
                              borderWidth: "0",
                            }}
                          />
                        </div>


                        <div className="offcanvas-header d-flex align-items-center justify-content-center pb-5" style={{ marginTop: "30px" }}>
                          <button
                            className="btn btn-danger"
                            type="submit"
                            disabled={saving}
                          >
                            {saving ? 'กำลังบันทึก...' : 'Confirm'}
                          </button>
                        </div>
                      </Form>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          open={showResetPassword}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5" style={{ marginTop: "30px", marginLeft: "30px", marginRight: "30px" }}>
                <span style={{ fontSize: "20px" }}>Reset Password</span>
                <button type="button"
                  className="btn btn-xs btn-icon btn-light btn-hover-primary"
                  id="kt_quick_user_close"
                  onClick={() => setShowResetPassword(false)}
                >
                  <i className="ki ki-close icon-xs text-muted" />
                </button>
              </div>

              <div className="modal-body">
                <Formik
                  initialValues={{
                    password: password,

                  }}


                  onSubmit={onSubmitResetPassword}
                  render={(formProps) => {
                    return (
                      <Form className="col">
                        <div className="row">

                          <Field
                            type="text"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control"
                            placeholder="Please insert password"
                            style={{
                              height: "38px",
                              width: "530px",
                              backgroundColor: "#F4F6F9",
                              borderRadius: "5px",
                              borderWidth: "0",
                            }}
                          />
                        </div>


                        <div className="offcanvas-header d-flex align-items-center justify-content-center pb-5" style={{ marginTop: "30px" }}>
                          <button
                            className="btn btn-primary"
                            type="submit"
                          //disabled={formProps.isSubmitting}
                          >
                            Confirm
                          </button>
                        </div>
                      </Form>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </CardBody>
    </Card>
  );
};
